export * from './dashboard.component';
export * from './dashboard.service';


// WEBPACK FOOTER //
// ./src/app/rm/dashboard/index.ts